import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useTheme } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createPassportTheme } from '../design/passportTheme';
import PassportPageShell from '../components/GigPassport/components/PassportPageShell';
import TogeeUniverseHeader from '../components/GigPassport/components/TogeeUniverseHeader';
import PassportBottomNav from '../components/layout/PassportBottomNav';
import { passportColors } from '../design/passportTokens';

export default function PassportLayout() {
  const baseTheme = useTheme();
  const passportTheme = React.useMemo(() => createPassportTheme(baseTheme), [baseTheme]);

  return (
    <ThemeProvider theme={passportTheme}>
      <Box
        className="passport-layout-wrapper"
        sx={{
          width: '100%',
          minHeight: '100vh',
          bgcolor: passportColors.background,
          color: passportColors.textPrimary,
          backgroundImage:
            'radial-gradient(circle at top left, rgba(211,118,51,0.08), transparent 34%), radial-gradient(circle at bottom right, rgba(0,227,253,0.06), transparent 34%)',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          overflowX: 'hidden',
        }}
      >
        {/* Unified Passport Header */}
        <TogeeUniverseHeader />

        {/* Content Area */}
        <PassportPageShell>
          <Outlet />
        </PassportPageShell>

        {/* Dedicated Mobile Bottom Navigation */}
        <PassportBottomNav />
      </Box>
    </ThemeProvider>
  );
}
